// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { contractedProductSearchResponseTransformer, getCustomerOrderHistoryResponseTransformer, getCustomerPositiveListResponseTransformer, getFavoriteListFullResponseTransformer, getFavoriteListsResponseTransformer, getOrderResponseTransformer, productSearchResponseTransformer, quickSearchResponseTransformer, searchAppropriationsResponseTransformer } from './transformers.gen';
import type { AddProductsToDefaultFavoriteListData, AddProductsToDefaultFavoriteListErrors, AddProductsToDefaultFavoriteListResponses, AddProductsToFavoriteListData, AddProductsToFavoriteListErrors, AddProductsToFavoriteListResponses, AddProductToDefaultFavoriteListData, AddProductToDefaultFavoriteListErrors, AddProductToDefaultFavoriteListResponses, AddProductToFavoriteListData, AddProductToFavoriteListErrors, AddProductToFavoriteListResponses, CalculateCartData, CalculateCartErrors, CalculateCartResponses, ContractedProductSearchData, ContractedProductSearchErrors, ContractedProductSearchResponses, CopyFavoriteListData, CopyFavoriteListErrors, CopyFavoriteListResponses, CreateFavoriteListData, CreateFavoriteListErrors, CreateFavoriteListResponses, CreateOrderData, CreateOrderErrors, CreateOrderResponses, DeleteFavoriteListData, DeleteFavoriteListErrors, DeleteFavoriteListResponses, EditFavoriteListData, EditFavoriteListErrors, EditFavoriteListResponses, GetAnonymousTokenData, GetAnonymousTokenErrors, GetAnonymousTokenResponses, GetB2bUserData, GetB2bUserErrors, GetB2bUserResponses, GetCurrentUserData, GetCurrentUserErrors, GetCurrentUserResponses, GetCustomerAddressesData, GetCustomerAddressesErrors, GetCustomerAddressesResponses, GetCustomerAgreementsData, GetCustomerAgreementsErrors, GetCustomerAgreementsResponses, GetCustomerByIdData, GetCustomerByIdErrors, GetCustomerByIdResponses, GetCustomerOrderHistoryData, GetCustomerOrderHistoryErrors, GetCustomerOrderHistoryResponses, GetCustomerPositiveListData, GetCustomerPositiveListErrors, GetCustomerPositiveListResponses, GetCustomerPriceListsData, GetCustomerPriceListsErrors, GetCustomerPriceListsResponses, GetCustomerProfileData, GetCustomerProfileErrors, GetCustomerProfileResponses, GetDefaultFavoriteListData, GetDefaultFavoriteListErrors, GetDefaultFavoriteListResponses, GetFavoriteListData, GetFavoriteListErrors, GetFavoriteListFullData, GetFavoriteListFullErrors, GetFavoriteListFullResponses, GetFavoriteListIdsByProductIdData, GetFavoriteListIdsByProductIdErrors, GetFavoriteListIdsByProductIdResponses, GetFavoriteListIdsByProductIdsData, GetFavoriteListIdsByProductIdsErrors, GetFavoriteListIdsByProductIdsResponses, GetFavoriteListIdsData, GetFavoriteListIdsErrors, GetFavoriteListIdsResponses, GetFavoriteListResponses, GetFavoriteListsData, GetFavoriteListsErrors, GetFavoriteListsResponses, GetMarketingPermissionsData, GetMarketingPermissionsErrors, GetMarketingPermissionsResponses, GetOrderData, GetOrderDeliveryNotesAsZipData, GetOrderDeliveryNotesAsZipErrors, GetOrderDeliveryNotesAsZipResponses, GetOrderErrors, GetOrderInvoicesAsZipData, GetOrderInvoicesAsZipErrors, GetOrderInvoicesAsZipResponses, GetOrderResponses, GetPricesData, GetPricesErrors, GetPricesResponses, HelloData, HelloResponses, ProductSearchData, ProductSearchErrors, ProductSearchResponses, PublicHelloData, PublicHelloResponses, QuickSearchData, QuickSearchErrors, QuickSearchResponses, RemoveProductFromFavoriteListData, RemoveProductFromFavoriteListErrors, RemoveProductFromFavoriteListResponses, SearchAppropriationsData, SearchAppropriationsErrors, SearchAppropriationsResponses, UpdateCustomerAddressData, UpdateCustomerAddressErrors, UpdateCustomerAddressResponses, UpdateDesiredQuantityData, UpdateDesiredQuantityErrors, UpdateDesiredQuantityResponses, UpdateMarketingPermissionsData, UpdateMarketingPermissionsErrors, UpdateMarketingPermissionsResponses, UserInfoData, UserInfoResponses } from './types.gen';
import { zAddProductsToDefaultFavoriteListData, zAddProductsToFavoriteListData, zAddProductToDefaultFavoriteListData, zAddProductToFavoriteListData, zCalculateCartData, zContractedProductSearchData, zCopyFavoriteListData, zCreateFavoriteListData, zCreateOrderData, zDeleteFavoriteListData, zEditFavoriteListData, zGetAnonymousTokenData, zGetB2bUserData, zGetCurrentUserData, zGetCustomerAddressesData, zGetCustomerAgreementsData, zGetCustomerByIdData, zGetCustomerOrderHistoryData, zGetCustomerPositiveListData, zGetCustomerPriceListsData, zGetCustomerProfileData, zGetDefaultFavoriteListData, zGetFavoriteListData, zGetFavoriteListFullData, zGetFavoriteListIdsByProductIdData, zGetFavoriteListIdsByProductIdsData, zGetFavoriteListIdsData, zGetFavoriteListsData, zGetMarketingPermissionsData, zGetOrderData, zGetOrderDeliveryNotesAsZipData, zGetOrderInvoicesAsZipData, zGetPricesData, zHelloData, zProductSearchData, zPublicHelloData, zQuickSearchData, zRemoveProductFromFavoriteListData, zSearchAppropriationsData, zUpdateCustomerAddressData, zUpdateDesiredQuantityData, zUpdateMarketingPermissionsData, zUserInfoData } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Remove product from favorite list
 *
 * Remove a product from a favorite list
 */
export const removeProductFromFavoriteList = <ThrowOnError extends boolean = true>(options: Options<RemoveProductFromFavoriteListData, ThrowOnError>) => (options.client ?? client).delete<RemoveProductFromFavoriteListResponses, RemoveProductFromFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zRemoveProductFromFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}/items/{productId}',
    ...options
});

/**
 * Add product to favorite list
 *
 * Add a product to a favorite list
 */
export const addProductToFavoriteList = <ThrowOnError extends boolean = true>(options: Options<AddProductToFavoriteListData, ThrowOnError>) => (options.client ?? client).post<AddProductToFavoriteListResponses, AddProductToFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zAddProductToFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}/items/{productId}',
    ...options
});

/**
 * Update desired quantity for product in favorite list
 *
 * Set or clear desired quantity for a product in a specific favorite list
 */
export const updateDesiredQuantity = <ThrowOnError extends boolean = true>(options: Options<UpdateDesiredQuantityData, ThrowOnError>) => (options.client ?? client).put<UpdateDesiredQuantityResponses, UpdateDesiredQuantityErrors, ThrowOnError>({
    requestValidator: async (data) => await zUpdateDesiredQuantityData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}/items/{productId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit favorite list
 *
 * Edit a favorite list by id
 */
export const editFavoriteList = <ThrowOnError extends boolean = true>(options: Options<EditFavoriteListData, ThrowOnError>) => (options.client ?? client).put<EditFavoriteListResponses, EditFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zEditFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Product search
 *
 * Product search by query
 */
export const productSearch = <ThrowOnError extends boolean = true>(options: Options<ProductSearchData, ThrowOnError>) => (options.client ?? client).post<ProductSearchResponses, ProductSearchErrors, ThrowOnError>({
    requestValidator: async (data) => await zProductSearchData.parseAsync(data),
    responseTransformer: productSearchResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/products/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quick search
 *
 * Search suggestions while typing: up to 3 products and up to 5 categories with the most hits, for a query of at least 3 characters
 */
export const quickSearch = <ThrowOnError extends boolean = true>(options: Options<QuickSearchData, ThrowOnError>) => (options.client ?? client).post<QuickSearchResponses, QuickSearchErrors, ThrowOnError>({
    requestValidator: async (data) => await zQuickSearchData.parseAsync(data),
    responseTransformer: quickSearchResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/products/quickSearch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get prices for products
 *
 * Get prices for specific products
 */
export const getPrices = <ThrowOnError extends boolean = true>(options: Options<GetPricesData, ThrowOnError>) => (options.client ?? client).post<GetPricesResponses, GetPricesErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetPricesData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/prices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves orders for given customer
 *
 * Retrieves orders for given customer by id
 */
export const getCustomerOrderHistory = <ThrowOnError extends boolean = true>(options: Options<GetCustomerOrderHistoryData, ThrowOnError>) => (options.client ?? client).post<GetCustomerOrderHistoryResponses, GetCustomerOrderHistoryErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCustomerOrderHistoryData.parseAsync(data),
    responseTransformer: getCustomerOrderHistoryResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/orderHistory',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create order
 *
 * Create order. Please note, that deliveryAddressId or deliveryAddress node has to be provided
 */
export const createOrder = <ThrowOnError extends boolean = true>(options: Options<CreateOrderData, ThrowOnError>) => (options.client ?? client).post<CreateOrderResponses, CreateOrderErrors, ThrowOnError>({
    requestValidator: async (data) => await zCreateOrderData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get marketing permissions
 *
 * Get marketing permissions
 */
export const getMarketingPermissions = <ThrowOnError extends boolean = true>(options: Options<GetMarketingPermissionsData, ThrowOnError>) => (options.client ?? client).get<GetMarketingPermissionsResponses, GetMarketingPermissionsErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetMarketingPermissionsData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/marketing/permissions/{email}',
    ...options
});

/**
 * Update marketing permissions
 *
 * Update marketing permissions
 */
export const updateMarketingPermissions = <ThrowOnError extends boolean = true>(options: Options<UpdateMarketingPermissionsData, ThrowOnError>) => (options.client ?? client).post<UpdateMarketingPermissionsResponses, UpdateMarketingPermissionsErrors, ThrowOnError>({
    requestValidator: async (data) => await zUpdateMarketingPermissionsData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/marketing/permissions/{email}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get favorite list IDs for current customer
 *
 * Fetch IDs of favorite lists for the current customer from the access token.
 */
export const getFavoriteListIds = <ThrowOnError extends boolean = true>(options?: Options<GetFavoriteListIdsData, ThrowOnError>) => (options?.client ?? client).get<GetFavoriteListIdsResponses, GetFavoriteListIdsErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetFavoriteListIdsData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelists/ids',
    ...options
});

/**
 * Get favorite list IDs containing specific products for current customer
 *
 * Fetch IDs of favorite lists for the current customer that contain the specified product IDs.
 */
export const getFavoriteListIdsByProductIds = <ThrowOnError extends boolean = true>(options: Options<GetFavoriteListIdsByProductIdsData, ThrowOnError>) => (options.client ?? client).post<GetFavoriteListIdsByProductIdsResponses, GetFavoriteListIdsByProductIdsErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetFavoriteListIdsByProductIdsData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelists/ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get favorite lists for current customer
 *
 * Fetch favorite lists for the current customer from the access token.
 */
export const getFavoriteLists = <ThrowOnError extends boolean = true>(options: Options<GetFavoriteListsData, ThrowOnError>) => (options.client ?? client).post<GetFavoriteListsResponses, GetFavoriteListsErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetFavoriteListsData.parseAsync(data),
    responseTransformer: getFavoriteListsResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add products to favorite list
 *
 * Add a products to a favorite list
 */
export const addProductsToFavoriteList = <ThrowOnError extends boolean = true>(options: Options<AddProductsToFavoriteListData, ThrowOnError>) => (options.client ?? client).post<AddProductsToFavoriteListResponses, AddProductsToFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zAddProductsToFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get favorite list with full product data (paginated)
 *
 * Fetch a favorite list with full product data. Pagination is provided in the request body.
 */
export const getFavoriteListFull = <ThrowOnError extends boolean = true>(options: Options<GetFavoriteListFullData, ThrowOnError>) => (options.client ?? client).post<GetFavoriteListFullResponses, GetFavoriteListFullErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetFavoriteListFullData.parseAsync(data),
    responseTransformer: getFavoriteListFullResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}/full',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Copy favorite list
 *
 * Create a copy of an existing favorite list (including its products). The copied list will never be set as default. If a list with the same name exists, an iterative suffix like ' (2)', ' (3)' is appended.
 */
export const copyFavoriteList = <ThrowOnError extends boolean = true>(options: Options<CopyFavoriteListData, ThrowOnError>) => (options.client ?? client).post<CopyFavoriteListResponses, CopyFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zCopyFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}/copy',
    ...options
});

/**
 * Add product to default favorite list
 *
 * Add a single product to the default favorite list for the current customer.
 */
export const addProductToDefaultFavoriteList = <ThrowOnError extends boolean = true>(options: Options<AddProductToDefaultFavoriteListData, ThrowOnError>) => (options.client ?? client).post<AddProductToDefaultFavoriteListResponses, AddProductToDefaultFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zAddProductToDefaultFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/items/{productId}',
    ...options
});

/**
 * Add products to default favorite list
 *
 * Add multiple products to the default favorite list for the current customer.
 */
export const addProductsToDefaultFavoriteList = <ThrowOnError extends boolean = true>(options: Options<AddProductsToDefaultFavoriteListData, ThrowOnError>) => (options.client ?? client).post<AddProductsToDefaultFavoriteListResponses, AddProductsToDefaultFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zAddProductsToDefaultFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get default favorite list for current customer
 *
 * Returns the default favorite list for the current customer scoped by headers.
 */
export const getDefaultFavoriteList = <ThrowOnError extends boolean = true>(options?: Options<GetDefaultFavoriteListData, ThrowOnError>) => (options?.client ?? client).get<GetDefaultFavoriteListResponses, GetDefaultFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetDefaultFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist',
    ...options
});

/**
 * Create favorite list
 *
 * Create a new favorite list for current customer
 */
export const createFavoriteList = <ThrowOnError extends boolean = true>(options: Options<CreateFavoriteListData, ThrowOnError>) => (options.client ?? client).post<CreateFavoriteListResponses, CreateFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zCreateFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update/create customer address
 *
 * Update/create customer address
 */
export const updateCustomerAddress = <ThrowOnError extends boolean = true>(options: Options<UpdateCustomerAddressData, ThrowOnError>) => (options.client ?? client).post<UpdateCustomerAddressResponses, UpdateCustomerAddressErrors, ThrowOnError>({
    requestValidator: async (data) => await zUpdateCustomerAddressData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/customers/updateAddress',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get customer addresses
 *
 * Get customer addresses
 */
export const getCustomerAddresses = <ThrowOnError extends boolean = true>(options: Options<GetCustomerAddressesData, ThrowOnError>) => (options.client ?? client).post<GetCustomerAddressesResponses, GetCustomerAddressesErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCustomerAddressesData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/customers/addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Calculate cart
 *
 * Calculate cart based on provided products and customer
 */
export const calculateCart = <ThrowOnError extends boolean = true>(options: Options<CalculateCartData, ThrowOnError>) => (options.client ?? client).post<CalculateCartResponses, CalculateCartErrors, ThrowOnError>({
    requestValidator: async (data) => await zCalculateCartData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cart',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get appropriations by given criteria
 *
 * Get appropriations by given criteria
 */
export const searchAppropriations = <ThrowOnError extends boolean = true>(options: Options<SearchAppropriationsData, ThrowOnError>) => (options.client ?? client).post<SearchAppropriationsResponses, SearchAppropriationsErrors, ThrowOnError>({
    requestValidator: async (data) => await zSearchAppropriationsData.parseAsync(data),
    responseTransformer: searchAppropriationsResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/appropriations/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Product search
 *
 * Product search by query
 */
export const contractedProductSearch = <ThrowOnError extends boolean = true>(options: Options<ContractedProductSearchData, ThrowOnError>) => (options.client ?? client).post<ContractedProductSearchResponses, ContractedProductSearchErrors, ThrowOnError>({
    requestValidator: async (data) => await zContractedProductSearchData.parseAsync(data),
    responseTransformer: contractedProductSearchResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agreements/products/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get customer positive list
 *
 * Get customer positive list
 */
export const getCustomerPositiveList = <ThrowOnError extends boolean = true>(options: Options<GetCustomerPositiveListData, ThrowOnError>) => (options.client ?? client).post<GetCustomerPositiveListResponses, GetCustomerPositiveListErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCustomerPositiveListData.parseAsync(data),
    responseTransformer: getCustomerPositiveListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agreements/positiveList',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get information about current user
 *
 * Get information about current user
 */
export const getCurrentUser = <ThrowOnError extends boolean = true>(options?: Options<GetCurrentUserData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCurrentUserData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/current',
    ...options
});

/**
 * Get information about B2B User
 *
 * Get information about B2B User
 */
export const getB2bUser = <ThrowOnError extends boolean = true>(options: Options<GetB2bUserData, ThrowOnError>) => (options.client ?? client).get<GetB2bUserResponses, GetB2bUserErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetB2bUserData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/b2b/{userId}',
    ...options
});

export const userInfo = <ThrowOnError extends boolean = true>(options?: Options<UserInfoData, ThrowOnError>) => (options?.client ?? client).get<UserInfoResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await zUserInfoData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user-info',
    ...options
});

/**
 * Get anonymous token
 *
 * Returns the saved anonymous token when X-Role=ANONYMOUS and required headers are present
 */
export const getAnonymousToken = <ThrowOnError extends boolean = true>(options?: Options<GetAnonymousTokenData, ThrowOnError>) => (options?.client ?? client).get<GetAnonymousTokenResponses, GetAnonymousTokenErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetAnonymousTokenData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/token',
    ...options
});

export const publicHello = <ThrowOnError extends boolean = true>(options?: Options<PublicHelloData, ThrowOnError>) => (options?.client ?? client).get<PublicHelloResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await zPublicHelloData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/public/hello',
    ...options
});

/**
 * Retrieves invoices in zip for given order
 *
 * Retrieves invoices in zip for given order
 */
export const getOrderInvoicesAsZip = <ThrowOnError extends boolean = true>(options: Options<GetOrderInvoicesAsZipData, ThrowOnError>) => (options.client ?? client).get<GetOrderInvoicesAsZipResponses, GetOrderInvoicesAsZipErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetOrderInvoicesAsZipData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{id}/invoices',
    ...options
});

/**
 * Retrieves delivery notes in zip for given order
 *
 * Retrieves delivery notes in zip for given order
 */
export const getOrderDeliveryNotesAsZip = <ThrowOnError extends boolean = true>(options: Options<GetOrderDeliveryNotesAsZipData, ThrowOnError>) => (options.client ?? client).get<GetOrderDeliveryNotesAsZipResponses, GetOrderDeliveryNotesAsZipErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetOrderDeliveryNotesAsZipData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{id}/deliveryNotes',
    ...options
});

/**
 * Retrieves a single order by id
 *
 * Retrieves a single order by id
 */
export const getOrder = <ThrowOnError extends boolean = true>(options: Options<GetOrderData, ThrowOnError>) => (options.client ?? client).get<GetOrderResponses, GetOrderErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetOrderData.parseAsync(data),
    responseTransformer: getOrderResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orders/{id}',
    ...options
});

export const hello = <ThrowOnError extends boolean = true>(options?: Options<HelloData, ThrowOnError>) => (options?.client ?? client).get<HelloResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await zHelloData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/hello',
    ...options
});

/**
 * Get favorite list IDs containing a specific product for current customer
 *
 * Fetch IDs of favorite lists for the current customer that contain the specified product ID.
 */
export const getFavoriteListIdsByProductId = <ThrowOnError extends boolean = true>(options: Options<GetFavoriteListIdsByProductIdData, ThrowOnError>) => (options.client ?? client).get<GetFavoriteListIdsByProductIdResponses, GetFavoriteListIdsByProductIdErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetFavoriteListIdsByProductIdData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelists/ids/{productId}',
    ...options
});

/**
 * Delete favorite list
 *
 * Delete a favorite list by id
 */
export const deleteFavoriteList = <ThrowOnError extends boolean = true>(options: Options<DeleteFavoriteListData, ThrowOnError>) => (options.client ?? client).delete<DeleteFavoriteListResponses, DeleteFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zDeleteFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}',
    ...options
});

/**
 * Get favorite list by id
 *
 * Fetch a favorite list by id
 */
export const getFavoriteList = <ThrowOnError extends boolean = true>(options: Options<GetFavoriteListData, ThrowOnError>) => (options.client ?? client).get<GetFavoriteListResponses, GetFavoriteListErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetFavoriteListData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/favoritelist/{favoriteListId}',
    ...options
});

/**
 * Get customer profile info
 *
 * Get customer profile info
 */
export const getCustomerProfile = <ThrowOnError extends boolean = true>(options?: Options<GetCustomerProfileData, ThrowOnError>) => (options?.client ?? client).get<GetCustomerProfileResponses, GetCustomerProfileErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCustomerProfileData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/customers/profile',
    ...options
});

/**
 * Get price lists for current customer
 *
 * Get price lists for current customer
 */
export const getCustomerPriceLists = <ThrowOnError extends boolean = true>(options?: Options<GetCustomerPriceListsData, ThrowOnError>) => (options?.client ?? client).get<GetCustomerPriceListsResponses, GetCustomerPriceListsErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCustomerPriceListsData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/customers/current/priceLists',
    ...options
});

/**
 * Get agreements for current customer
 *
 * Get agreements for current customer
 */
export const getCustomerAgreements = <ThrowOnError extends boolean = true>(options?: Options<GetCustomerAgreementsData, ThrowOnError>) => (options?.client ?? client).get<GetCustomerAgreementsResponses, GetCustomerAgreementsErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCustomerAgreementsData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/customers/current/agreements',
    ...options
});

/**
 * Get information about customer
 *
 * Get information about customer
 */
export const getCustomerById = <ThrowOnError extends boolean = true>(options?: Options<GetCustomerByIdData, ThrowOnError>) => (options?.client ?? client).get<GetCustomerByIdResponses, GetCustomerByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetCustomerByIdData.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/customers/current',
    ...options
});
